import { Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import * as PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles(() => ({
  buttonSave: {
    border: '1px solid #f44336',
    color: '#f44336',
    width: 90,
    height: 36,
    borderRadius: 5,
    backgroundColor: '#eee',
    textTransform: 'capitalize',
    '&:hover': {
      background: '#f43036',
      color: 'white',
    },
  },
}));

const CancelButton = ({ children, onClick, type }) => {
  const classes = useStyles();
  return (
    <Button type={type} variant="outlined" className={classes.buttonSave} onClick={onClick}>
      <Typography>{children}</Typography>
    </Button>
  );
};
CancelButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
  type: PropTypes.string,
};

CancelButton.defaultProps = {
  type: 'button',
};

export default CancelButton;
